import type { Subscription } from '~/interfaces/subscriptions';

const useSubscription = (subscription: Subscription, isLoggedIn: boolean) => {
  const isInactive = subscription.status === 'inactive';
  const isFreeTier = subscription.tier === 'free';
  const isPremiumTier = subscription.tier === 'premium';
  const isPermanentlyUpgraded = subscription.premium_tiers.some((tier) => tier.permanent);

  const canUnsubscribe =
    ['active', 'pending'].includes(subscription.status) && ((isPremiumTier && isLoggedIn) || isFreeTier);
  const canDowngrade = isPremiumTier && isLoggedIn && !isPermanentlyUpgraded;

  return {
    isFreeTier,
    isInactive,
    isPremiumTier,
    isPermanentlyUpgraded,
    canUnsubscribe,
    canDowngrade,
  };
};

export default useSubscription;
